export const AdminZeromatchingDashboards = {
  AdminZeromatchingDashboards: 
  {
    permissionsId:'768d7f99-8e6c-46c9-7953-08dcaf947ea8',
    permissionsName:'Admin Zeromatching' , 
    componentsId:null,
    components:null
  }
} ;
